import { call, put, takeEvery, delay } from "redux-saga/effects"
import {
  getStaffProfileAPI,
  getStaffAttendanceAPI,
  getStaffTimeTableAPI,
} from "./api"
import * as types from "./constant"
import {
  getStaffProfileSuccess,
  getStaffProfileFailed,
  getStaffAttendanceSuccess,
  getStaffAttendanceFailed,
  getTimeTableFailed,
  getTimeTableSuccess,
} from "./action"

function* getStaffProfileSaga() {
  try {
    const response = yield call(getStaffProfileAPI)
    if (response) {
      delay(100)
      yield put(getStaffProfileSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(getStaffProfileFailed(error))
  }
}

function* getStaffAttendanceSaga(action) {
  try {
    const response = yield call(getStaffAttendanceAPI, action.payload)
    if (response) {
      yield put(getStaffAttendanceSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(getStaffAttendanceFailed(error))
  }
}
function* getTimeTableSaga() {
  try {
    const response = yield call(getStaffTimeTableAPI)
    if (response) {
      yield put(getTimeTableSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(getTimeTableFailed(error))
  }
}
function* TeacherDashboardSaga() {
  yield takeEvery(types.GET_STAFF_START, getStaffProfileSaga)
  yield takeEvery(types.GET_STAFF_ATTENDANCE_START, getStaffAttendanceSaga)
  yield takeEvery(types.GET_TIMETABLE_DAYS_REQUEST, getTimeTableSaga)
}
export default TeacherDashboardSaga
